var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box, List } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { CircularProgress } from "../../../../../Atoms";
import BrokerListItem from "./BrokerListItem";
var BrokerList = function (_a) {
    var brokers = _a.brokers, moreBrokersAvailable = _a.moreBrokersAvailable, requestMoreBrokers = _a.requestMoreBrokers;
    return (_jsx(List, __assign({ sx: {
            overflow: "hidden",
            padding: "0px",
        } }, { children: _jsx(InfiniteScroll, __assign({ dataLength: brokers.length, next: requestMoreBrokers, hasMore: moreBrokersAvailable, height: 520, style: { overflowX: "hidden" }, loader: _jsx(Box, __assign({ sx: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    mt: "10px",
                } }, { children: _jsx(CircularProgress, {}) })) }, { children: brokers.map(function (broker, i) { return (_jsx(BrokerListItem, { broker: broker, showBorder: i !== brokers.length - 1 }, broker.id + i + broker.name)); }) })) })));
};
export default React.memo(BrokerList);
